import React from 'react'
import "../Assets/styles/agency.css"
import { CiCreditCard2 } from "react-icons/ci";
import { CgWebsite } from "react-icons/cg";
import { CiMobile3 } from "react-icons/ci";
import { SlSpeech } from "react-icons/sl";
import { BsRobot } from "react-icons/bs";
import { AiOutlineSolution } from "react-icons/ai";


const Agency = () => {
  return (
    <>
        <div className="container-lg">
            <div className="header" data-aos="fade-right" data-aos-duration="1000">
                <span>Services</span> 
                <h3>Quality Service</h3>
            </div>
          {/* <div className="title">
             <p>  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmodtempor incidiunt labore etdolore magna aliqua. Quis ipsum suspendisse ultrices gravida.
             </p>
            <div className="bar" />
         </div> */}
         <div className="row">
           <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1000ms">
             <div className="single-services">
               <div className="icon">
               <SlSpeech />
               </div>
               <h3>IT Consultancy</h3>
               <p>Provide expert advice and guidance on IT strategies, infrastructure, and technology adoption. <br />Conduct technology audits, assess existing systems, and recommend improvements. <br />Offer insights on cybersecurity, data management, cloud computing, and digital transformation initiatives.
               </p>
             </div>
            </div>
           <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1000ms">
            <div className="single-services">
              <div className="icon">
              <CgWebsite />
              </div>
              <h3>Web Development</h3>
              <p>Offer custom web development services tailored to client needs. <br /> Develop responsive and user-friendly websites using modern technologies. <br /> Provide solutions for various industries, including corporate websites, portfolios, blogs, and more.
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1000ms">
            <div className="single-services">
             <div className="icon">
             <BsRobot />
             </div>
             <h3>AI/ML</h3>
             <p>Implement AI and ML technologies to enhance business processes and decision-making. <br />Develop custom solutions such as recommendation engines, predictive analytics, and natural language processing. <br />Utilize machine learning algorithms to analyze data, identify patterns, and make data-driven predictions.</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1000ms">
        <div className="single-services">
          <div className="icon">
          <CiMobile3 />
          </div>
          <h3>App Development</h3>
          <p>
          Create mobile applications for iOS and Android platforms. <br />Develop native or hybrid apps based on client requirements. <br />Focus on intuitive user interfaces, performance optimization, and seamless user experiences.
          </p>
        </div>
      </div>
      <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1000ms">
        <div className="single-services">
          <div className="icon">
          <CiCreditCard2 />
          </div>
          <h3>E-commerce Development</h3>
          <p>
          Design and develop ecommerce platforms for businesses looking to sell products or services online. <br />Integrate secure payment gateways, inventory management systems, and order processing functionalities. <br />Optimize for search engines and enhance user experience to drive sales and conversions.
          </p>
        </div>
      </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1000ms">
              <div className="single-services">
              <div className="icon">
              <AiOutlineSolution />
               </div>
               <h3>Web 3.0</h3>
               <p>
               Explore the decentralized web and blockchain technologies. <br />Develop decentralized applications (dApps) using blockchain platforms like Ethereum, Solana, or Polkadot. <br />Implement smart contracts, decentralized finance (DeFi) solutions, and non-fungible tokens (NFTs).                
               </p>
              </div>
            </div>
          </div>
        </div>
    </>
  )
}

export default Agency